/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';
    import ISystemConfig = Models.ISystemConfig;
    import SystemConfigKeys = Models.SystemConfigKeys;
    import SystemConfig = Application.Models.SystemConfig;


    export class BackendConfigService {
        public static $name: string = "backendConfigService";
        public static $inject: string[] = ['$q', 'backendService'];

        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = 'systemConfigs/';
        private healthChecksPath: string = 'healthChecks/';


        constructor(private $q: ng.IQService,
                    private backendService: Services.BackendService) {
            
        }

        /**
         * Gets a system config from the backend
         *
         * @param key key of the config
         * @return retrieved system config
         */
        public getSystemConfigByKey(key: string): ng.IPromise<ISystemConfig> {
            let url: string = this.backendBaseUrl + this.servicePath + 'findByKey?key=' + key;
            return this.backendService.get(url).then((result: ng.IHttpPromiseCallbackArg<ISystemConfig>) => {
                return result.data;
            }).catch( () => {
                return new SystemConfig();
            });
        }

        /**
         * Checks if the portal is in monitoring only mode
         *
         * @return true if the portal is in monitoring only mode, false otherwise
         */
        public isMonitoringOnlyInstance(): ng.IPromise<boolean> {
            return this.httpGetBoolean(SystemConfigKeys.isMonitoringOnlyInstanceEndpoint);
        }

        /**
         * Checks if the portal has digicon activated
         *
         * @return true if digicon is activated, false otherwise
         */
        public hasDigicon(): ng.IPromise<boolean> {
            return this.httpGetBoolean(SystemConfigKeys.hasDigiconEndpoint);
        }

        /**
         * Checks if the portal is in maintenance
         *
         * @return true if the portal is in maintenance, false otherwise
         */
        public isMaintenance(): ng.IPromise<boolean> {
            return this.httpGetBoolean(SystemConfigKeys.isMaintenanceEndpoint);
        }

        /**
         * Checks if a service is available
         *
         * @param serviceName name of the service
         * @return true if the service is available, false otherwise
         */
        public isServiceAvailable(serviceName: string): ng.IPromise<Boolean> {
            let url: string = this.backendBaseUrl + this.healthChecksPath + 'isServiceAvailable?serviceName=' + serviceName;
            return this.backendService.get(url).then((result: ng.IHttpPromiseCallbackArg<Boolean>) => {
                return result.data;
            });
        }

        /**
         * Get a boolean system config value
         *
         * @param endpoint endpoint of the API that returns the boolean
         * @return value of the system config
         */
        private httpGetBoolean(endpoint: string): ng.IPromise<boolean> {
            let url: string = this.backendBaseUrl + this.servicePath + endpoint;
            return this.backendService
                .get(url)
                .then((result: ng.IHttpPromiseCallbackArg<Boolean>) => {
                    return result.data;
                });
        }
    }
}
